
/**
 * @import internal modules
 */
import AuthentificationGrid  from "@apps-widgets/authentification/component";
import Copyright  from "@apps-widgets/copyright/component";

/**
 * @import external modules
 */

import * as React from "react";
import { pure } from 'recompose';
import * as  Particles from 'react-particles-js';
// import * as shortid from 'shortid';
// component
const Component: React.FunctionComponent<any> = (props: any): any =>{
    
    
    const {onSubmitValue,emptyError, authentification,faillure,success,checked, onChangeRadio, onChange ,connexionError } = props;

    return(
        <div className="login-page" >
        <div style={{  position: "absolute", top: 0, left: 0, width: "100%",  height: "100%"}}>
            <Particles.default   params={{
                    "particles": {
                        "interactivity": {
                            "detect_on": "window",
                            "events": {
                                "onhover": {
                                    "enable": false,
                                    "mode": "repulse"
                                }
                            }
                        },
                        "number": {
                            "value": 100
                        },
                        "opacity": {
                            "anim": {
                                "enable": false,
                                "opacity_min": 0.1,
                                "speed": 1,
                                "sync": false
                            },
                            "random": false,
                            "value": 0.1, 
                        },
                        "retina_detect": true,
                       
                        "size": {
                            "value": 5
                        },
                        
                    }
                    
                }} />
                <div style={{  position: "absolute", top: 0, left: 0, width: "100%",  height: "100%"}}>
                    { authentification &&  <AuthentificationGrid connexionError={connexionError} emptyError={emptyError} onLogin={onSubmitValue} checked={checked} onChangeRadio={onChangeRadio} onChange={onChange} classnames="authentification" faillure={faillure} success={success}/> /* Call authentification component */}
                    <Copyright classnames="copyright"/>
                </div>
             </div>
        </div>
        
    )
}


export default pure(Component);


// WEBPACK FOOTER //
// ./src/apps/components/@pages/login/component.tsx